import useProfileStore from '~/store/profile';

export default defineNuxtPlugin(() => {
  const profileStore = useProfileStore();

  const cfg = useRuntimeConfig();
  if (cfg.public.SENTRY_ENV !== 'production') {
    return;
  }

  const url = useRequestURL();
  const hostname = url.hostname;
  const tld = hostname.split('.').pop();

  const pixelMap = {
    am: '2170654943286875',
    app: '9340488419403038',
  };

  const pixelId = pixelMap[tld] || 'default-id';

  const userInfo = {};

  if (profileStore?.profile) {
    userInfo.em = profileStore.profile.email;
    userInfo.fn = profileStore.profile.firstName;
    userInfo.ln = profileStore.profile.lastName;
  }

  useHead({
    script: [
      {
        innerHTML: `
          !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
              n.callMethod
                ? n.callMethod.apply(n, arguments)
                : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}', ${JSON.stringify(userInfo)});
          fbq('track', 'PageView');
        `,
      },
    ],
  });
});
